<script>
export default {}
</script>
<template>
  <div class="d-flex justify-content-center align-items-center flex-fill">
    <div class="spinner-border" style="width: 1rem; height: 1rem" role="status">
      <span class="sr-only">{{ $t('loading') }}</span>
    </div>
  </div>
</template>
